import { ref, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a858361"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bill-board"
};
import BoardHeader from './components/BoardHeader.vue';
import BoardTable from './components/BoardTable.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'reconciliation'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const queryData = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.initTableData(obj);
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BoardHeader, {
        onGetFilterData: queryData
      }), _createVNode(BoardTable, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});